export const slotHistoryStore = {
  enableSave: true, // enabled true will add a command history in undo stack
  maxStack: 5, // Max stack saved.
  isLoading: false,
  undoStack: [],
  // will add redo[] in the future
};
